import Request from '@/plugins/request'

export function getOrders(params) {
  return Request.get('orders', {
    params,
  })
}

export function createOrder() {
  return Request.get(`orders/create`)
}

export function storeOrder(data) {
  return Request.post('orders', data)
}

// 退单
export function refuseOrder(order_id, data) {
  return Request.post(`orders/${order_id}/refuse`, data)
}

// 修改发货状态
export function modifyDeliveryStatus(order_id, data) {
  return Request.post(`orders/${order_id}/delivery-status`, data)
}

export function updateOrder(id, data) {
  return Request.put(`orders/${id}`, data)
}

export function editOrder(id) {
  return Request.get(`orders/${id}/edit`)
}

export function destroyOrder(id) {
  return Request.delete(`orders/${id}`)
}

export function exportOrder(params) {
  return Request.get('orders/export', { params })
}

// 物流信息
export function expressOrder(order_id) {
  return Request.post(`orders/${order_id}/express`)
}

// 修改物流信息
export function modifyDeliveryStatusExpress(order_id, data) {
  return Request.post(`orders/${order_id}/delivery-express`, data)
}

// 打印小票
export function printerOrder(order_id) {
  return Request.post(`orders/${order_id}/printer`)
}
